<div class="topbar">
  <div class="brand" aria-label="Breadcrumb">
    <span class="dot" aria-hidden="true"></span>
    <h1 class="page-title">{{ pageTitle }}</h1>
  </div>
  <div class="topbar-actions">
    <a
      routerLink="/cart"
      class="nav-link cart-link"
      title="Shopping Cart"
      [attr.aria-label]="'Shopping cart with ' + cartItemCount() + ' items'"
    >
      <i class="fas fa-shopping-cart" aria-hidden="true"></i>
      <span class="cart-badge" *ngIf="cartItemCount() > 0">{{
        cartItemCount()
      }}</span>
    </a>
  </div>
  <div
    class="topbar-active-fleet"
    *ngIf="!hideFleetSelector() && activeFleetName() as name; else noFleet"
  >
    <i class="fas fa-layer-group" aria-hidden="true"></i>
    <span class="fleet-name">{{ name }}</span>
    <div class="fleet-selector">
      <button
        type="button"
        class="nav-link"
        (click)="toggleFleetSelector()"
        aria-haspopup="listbox"
        [attr.aria-expanded]="showFleetSelector()"
      >
        Change
      </button>
      <div class="fleet-dropdown" *ngIf="showFleetSelector()">
        <input
          type="text"
          class="fleet-search"
          placeholder="Search fleets…"
          (input)="onFleetFilterInput($any($event.target).value)"
        />
        <div class="fleet-options" role="listbox">
          <div
            class="fleet-option"
            *ngFor="let f of filteredFleets()"
            role="option"
            [attr.aria-selected]="isActive(f._id)"
            (click)="selectFleet(f._id)"
          >
            <span class="label">{{ f.label || f._id }}</span>
            <span class="id">{{ f._id }}</span>
          </div>
          <div class="empty" *ngIf="filteredFleets().length === 0">
            No matches
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noFleet>
    <div class="topbar-active-fleet">
      <div class="fleet-selector" *ngIf="!hideFleetSelector()">
        <button type="button" class="nav-link" (click)="toggleFleetSelector()">
          Select a fleet
        </button>
        <div class="fleet-dropdown" *ngIf="showFleetSelector()">
          <input
            type="text"
            class="fleet-search"
            placeholder="Search fleets…"
            (input)="onFleetFilterInput($any($event.target).value)"
          />
          <div class="fleet-options" role="listbox">
            <div
              class="fleet-option"
              *ngFor="let f of filteredFleets()"
              role="option"
              [attr.aria-selected]="isActive(f._id)"
              (click)="selectFleet(f._id)"
            >
              <span class="label">{{ f.label || f._id }}</span>
              <span class="id">{{ f._id }}</span>
            </div>
            <div class="empty" *ngIf="filteredFleets().length === 0">
              No matches
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
